import { Component, Injectable } from '@angular/core';

@Component({
  selector: 'app-closed',
  templateUrl: './application-closed.component.html',
  styleUrls: ['./application-closed.component.scss'],
  standalone: false
})
@Injectable()
export class ApplicationClosedComponent {}
